import { Card, CardBody, Col } from "reactstrap";
import { SizesModal } from "../../../../Constant";
import { SIZE_DATA } from "../../../../Data/UiKit/Modal";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import FullScreenModal from "./FullscreenModal";
import ExtraLargeModal from "./ExtraLargeModal";
import LargeModal from "./LargeModal";
import SmallModal from "./SmallModal";

const SizeModalCart = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={SizesModal} span={SIZE_DATA} />
        <CardBody className="badge-spacing">
          <FullScreenModal />
          <ExtraLargeModal />
          <LargeModal />
          <SmallModal />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SizeModalCart;
